/**
 * @fileoverview GET handler for the "/companies/:company_id/ai_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAiSettings } from "./constants";
import type { CompanyAiSettingsResult } from "./types";

export const getCompanyAiSettings = reactQueryFetcherAdapter(
  companiesCompanyIdAiSettings,
  (signal: AbortSignal, companyId: string): Promise<CompanyAiSettingsResult> => {
    return fetch(`/companies/${companyId}/ai_settings`, "GET", {}, { signal });
  }
);
